module.exports = "/images/audit-log.svg?48b7d21572cb14abde38adbe5d216344";